// Basic
import { useState } from 'react';
import { useParams } from 'react-router-dom';
// Store & actions
import actionsSims from '@/app/modules/sims/api/actionsSims';
// Components
import Page from '@/common-utils/components/structure/page/Page';
import Entity from '@/common-utils/components/renders/entity/Entity';
import Icon from '@/common-utils/components/renders/icon/Icon';
import SimGroupDetails from '@/app/modules/sims/components/details/SimGroupDetails';
import Spinner from '@/common-utils/components/renders/spinner/Spinner';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/common-utils/components/ui/accordion';
// Common
import RouteUrls from '../../enums/RouteUrls';
import ICONS from '@/common-utils/enums/icons';
import SIM_CARDS_TABS from '../../enums/tabs/SimCardsTabs';

/**
 * @returns {JSX} SimCardGroupDetails
 */
function SimCardGroupDetails() {
    // URL Params
    const { groupId } = useParams();

    // API Calls
    const { data: simGroup, isLoading } = actionsSims.getSimGroupDetails(groupId, true);

    // State
    const [openSimGroupDetails, setOpenSimGroupDetails] = useState(true);

    return (
        <Page>
            <Page.Header
                route={RouteUrls.SIM_CARDS_GROUP_DETAILS}
                prevView={SIM_CARDS_TABS.SIM_GROUPS.name}
                routeBase={RouteUrls.SIM_CARDS}
            />
            {isLoading ?
                <Spinner className='full-screen-loading' /> :
                <Page.Body>
                    <Accordion type='multiple' defaultValue={['item-1']}>
                        <AccordionItem
                            className='rounded-md'
                            value='item-1'
                        >
                            <AccordionTrigger
                                className='opacity-[.8]'
                                open={openSimGroupDetails}
                                onClick={() => setOpenSimGroupDetails(!openSimGroupDetails)}
                            >
                                <div className='flex items-center gap-2'>
                                    <Icon icon={ICONS.GPRS} />
                                    <Entity entity={'page.sim_group.title'} />
                                </div>
                            </AccordionTrigger>
                            <AccordionContent>
                                <SimGroupDetails simGroup={simGroup} />
                            </AccordionContent>
                        </AccordionItem>
                    </Accordion>
                </Page.Body>
            }
        </Page>
    );
}

export default SimCardGroupDetails;